var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clock-container"}},[_c('div',{attrs:{"id":"clock"}},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.currentTime))]),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.currentDate))])])])}
var staticRenderFns = []

export { render, staticRenderFns }